import { render, staticRenderFns } from "./ManagementPurchasesAdd.vue?vue&type=template&id=4ee179f8&scoped=true"
import script from "./ManagementPurchasesAdd.vue?vue&type=script&lang=js"
export * from "./ManagementPurchasesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee179f8",
  null
  
)

export default component.exports